import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { makeRequest2 } from '../../../../../../utils/makeRequest';
import { useFacilityStore } from '../../../../../../app/z-store/store';
import { toastify } from '../../../../../../utils/toast';

const OnOffLogsTab = () => {
    const { meterId } = useParams();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [onOffLogs, setOnOffLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const selectedFacilityId = useFacilityStore((state) => state.facilityId);

    useEffect(() => {
        if (meterId && selectedFacilityId) {
            fetchMeterLogs();
        }
    }, [meterId, selectedFacilityId]);

    const fetchMeterLogs = async () => {
        try {
            setLoading(true);
            let endpoint = `/api/app/power_meter_management/controllers/commands/get_meter_logs/${meterId}`;
            
            // Add date filters if they exist
            const params = new URLSearchParams();
            if (startDate) params.append('start_date', startDate);
            if (endDate) params.append('end_date', endDate);
            
            if (params.toString()) {
                endpoint += `?${params.toString()}`;
            }

            const response = await makeRequest2(endpoint, 'GET');

            if (response && response.success) {
                // Ensure we're setting an array
                const logsData = response.data.data || [];
                setOnOffLogs(Array.isArray(logsData) ? logsData : []);
            } else if (response && response.data.data) {
                // Handle case where response structure is different
                const logsData = response.data.data || response.data || [];
                setOnOffLogs(Array.isArray(logsData) ? logsData : []);
            } else {
                toastify(response?.error || 'Failed to fetch meter logs', 'error');
                setOnOffLogs([]);
            }
        } catch (error) {
            console.error('Error fetching meter logs:', error);
            toastify('An error occurred while fetching meter logs', 'error');
            setOnOffLogs([]);
        } finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        fetchMeterLogs();
    };

    const formatDateTime = (timestamp) => {
        if (!timestamp) return '-';
        
        try {
            const date = new Date(timestamp);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });
        } catch (error) {
            return timestamp;
        }
    };

    const dateTimeBodyTemplate = (rowData) => {
        return formatDateTime(rowData.timestamp);
    };

    return (
        <div className="tab-pane show active" role="tabpanel">
            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-md-8 col-xs-12 mt-2">
                                    <div className="row">
                                        <div className="col-md-4 col-xs-5 mt-2">
                                            <label>Start Date</label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4 col-xs-5 mt-2">
                                            <label>End Date</label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4 col-xs-2 mt-2">
                                            <label>&nbsp;</label>
                                            <Button
                                                label="Filter"
                                                className="form-control"
                                                onClick={handleFilter}
                                                loading={loading}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="dt-responsive table-responsive">
                                <DataTable
                                    value={onOffLogs}
                                    loading={loading}
                                    emptyMessage="No command logs found."
                                    sortMode="multiple"
                                    paginator
                                    rows={10}
                                    stripedRows
                                    tableStyle={{ minWidth: '50rem' }}
                                >
                                    <Column 
                                        field="command" 
                                        sortable 
                                        header="Command" 
                                    />
                                    <Column 
                                        field="platform" 
                                        sortable 
                                        header="Platform" 
                                    />
                                    <Column 
                                        field="timestamp" 
                                        sortable 
                                        header="Date & Time" 
                                        body={dateTimeBodyTemplate} 
                                    />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnOffLogsTab;